import { MutableRefObject, useRef } from 'react'

export default function useOptionalArgumentRef<T = any>(
  optionalRef: MutableRefObject<T> | undefined,
  defaultValue: any
) {
  const fallbackRef = useRef<T>(defaultValue)
  return optionalRef ?? fallbackRef
}
